import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import { useStore } from '../../../store';
import { AppDetailsContext } from '../AppDetails';
import SidebarCategories from './SidebarCategories';
import SidebarHelpAndSupport from './SidebarHelpAndSupport';
import SidebarInstallationInstructions from './SidebarInstallationInstructions';
import SidebarMetaInfo from './SidebarMetaInfo';
import SidebarPublisher from './SidebarPublisher';
import SidebarTags from './SidebarTags';
import SlnSideBarDocuments from './SlnSideBarDocuments';
import SlnSidebarMetaInfo from './SlnSidebarMetaInfo';

const SideBar = () => {
  const { cloud, isPreview } = useContext(AppDetailsContext);
  const { id } = useParams();
  const acquired = useStore((state) => state.acquired);
  const trialAppAcquired = useStore((state) => state.trialAppAcquired);
  const detailScreenLoading = useStore((state) => state.detailScreenLoading);
  /** @type {import('@action-types/ecApp').AppDetails} */
  const detailScreen = useStore((state) => state.detailScreen);
  const solutionMedia = detailScreen?.solutionDetails?.solutionMedia;
  const internalSolutionMedia = detailScreen?.solutionDetails?.internalFields?.solutionMedia;
  const appType = detailScreen?.appType;
  const isSLN = appType === 'SLN';

  return (
    //@TODO: send detailScreen object
    <>
      {isSLN ? (
        <SlnSidebarMetaInfo />
      ) : (
        <SidebarMetaInfo
          data-testid="sidebar-meta-info"
          optionalProducts={detailScreen?.optionalProducts}
          publishedDate={detailScreen?.publishedDate}
          version={detailScreen?.version}
          packageSize={detailScreen?.packageSize}
          languages={detailScreen?.languages}
          hostApps={detailScreen?.hostApps}
          categories={detailScreen?.categories}
          platforms={detailScreen?.platforms}
          requiresInstallation={detailScreen?.requiresInstallation}
          requiresSignIn={detailScreen?.requiresSignIn}
          requiresPayment={detailScreen?.requiresPayment}
          licensing={detailScreen?.licensing}
          metaInfoLoading={detailScreenLoading}
          supportedProducts={detailScreen?.supportedProducts}
          isDownloadable={detailScreen?.isDownloadable}
          type={cloud}
          appType={appType}
        />
      )}

      {cloud?.toLowerCase() === 'cc' && (acquired || trialAppAcquired) && appType?.toLowerCase() === 'zxp' && (
        <SidebarInstallationInstructions id={id} name={detailScreen?.name} versionId={detailScreen?.appVersionId} />
      )}

      <SidebarPublisher />
      <SidebarHelpAndSupport />
      {solutionMedia && <SlnSideBarDocuments solutionMedia={solutionMedia} title="Documentation" />}
      {internalSolutionMedia && (
        <SlnSideBarDocuments solutionMedia={internalSolutionMedia} title="Internal documentation" />
      )}

      <SidebarCategories
        categoryIds={detailScreen?.categoryIds}
        data-testid="sidebar-categories"
        appType={appType}
        type={cloud}
        isPreview={isPreview}
      />
      <SidebarTags
        customTags={detailScreen?.customTags}
        standardTags={detailScreen?.standardTags}
        data-testid="sidebar-tags"
        appType={appType}
        type={cloud}
        isPreview={isPreview}
      />
    </>
  );
};

export default SideBar;
